import {isNotNilOrEmpty} from 'ramda-adjunct';

export type LanguageContentStatus = 'complete' | 'partial' | 'empty';

export function getLanguageContentStatus(
  content: {titleExtension?: string | null; description?: string | null} | undefined
): LanguageContentStatus {
  const hasTitleExtension = isNotNilOrEmpty(content?.titleExtension);
  const hasDescription = isNotNilOrEmpty(content?.description);

  if (hasTitleExtension && hasDescription) {
    return 'complete';
  }
  if (hasTitleExtension || hasDescription) {
    return 'partial';
  }
  return 'empty';
}
